import styles from "./HelpAIThinking.module.css";
import loadingGif from "../../../src/components/HelpAIChat/images/loading.gif"; 


const HelpAIThinking = () => {
  // return <div className={styles.progress_bar}><div className={styles.progress_fill}></div></div>;
  // return <span className={styles.thinking}></span>;
  return (
    <span className={styles.thinking_img}>
      <img src={loadingGif} alt="loading" className={styles.loadingImage} />
    </span>
  );
};

HelpAIThinking.displayName = "HelpAIThinking";
export default HelpAIThinking;
